import { render } from "./TheHelpChatbot.vue?vue&type=template&id=0a97b656"
import script from "./TheHelpChatbot.vue?vue&type=script&lang=js"
export * from "./TheHelpChatbot.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__